import { VERSION } from "../../core/utils/constants.js";
export function versionCommand(): void {
  console.log(VERSION);
}
